import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { LocalCacheService } from '../../../../core/local-cache/local-cache.service';
import { ISubheaderLeftSection } from '../sub-header.modal';
import { SubheaderHandlerService } from '../../../services/subheader-handler.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'app-subheader-left-section',
    templateUrl: './left-section.component.html'
})
export class SubHeaderLeftSectionComponent implements OnInit, OnDestroy {
    @Input() details: ISubheaderLeftSection;
    @Output() btnClick= new EventEmitter<string>();
    currentPageNameSubscription: Subscription;
    currentPageName: string;
    lockStatus: boolean;
    lockedBySameUser: boolean;
    caseId: number;

    constructor(
        private storage: LocalCacheService,
        private subHeaderService: SubheaderHandlerService) {
    }

    ngOnInit() {
        this.currentPageNameSubscription = this.subHeaderService.currentPageName$.subscribe((pageNameCaseId) => {
            this.updatePageName(pageNameCaseId);
        });
        //console.log(this.details);
    }

    updatePageName(pageNameCaseId: any) {
        this.currentPageName = pageNameCaseId.pageName;
        if (this.currentPageName === 'evaluator') {
            // Browser back on dashboard
            this.lockStatus = false;
        } else if (pageNameCaseId.caseId) {
            this.caseId = pageNameCaseId.caseId;
            this.subHeaderService.lockDetails$.subscribe(resp => {
                this.lockStatus = resp;
            });
        }
    }

    btnClickInSubhead(which: string) {
        this.btnClick.emit(which);
    }

    closeClicked() {
        const lockId = this.storage.fetchData('lockId');
        if (lockId !== null && lockId !== undefined) {
            this.subHeaderService.closeClicked(this.currentPageName);
            // this.timeoutService.deleteLock().subscribe(result => {
            // });
        }
    }

    ngOnDestroy() {
        this.currentPageNameSubscription.unsubscribe();
    }
}





// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/sub-header/left-section/left-section.component.ts